<div *ngIf="preReport" id="wrap">
  <div id="head_wrap">
    <div  class="common-back-btn-sight" id="closeBtn"  (click)="close()">
      <span>×</span>
    </div>

    <h1 id="name" class="fontSize18">{{appRename.getShowName(reportName)}}</h1>

    <img src="../../assets/picture/hrreport/success.png" alt="" id="success" *ngIf="mode==2&&postLevel>=5">
    <img src="../../assets/picture/hrreport/fail.png" alt="" id="fail" *ngIf="mode==2&&postLevel<5">

  </div>

  <div id="space"></div>

  <div id="level" class="fontSize18">
    <h1 id="title" class="fontSize24">能力等级<span *ngIf="mode==2">对比</span></h1>
    <div id="pre_wrap" *ngIf="mode==1">
      <div class="bar_bottom" id="pre_wrap_left">
        <div class="bar_top level{{preLevel}}"></div>
      </div>
      <div id="pre_wrap_right">
        <span class="fontSize16 wrap_text_1">L{{preLevel}}</span><span class="fontSize14">&nbsp;/&nbsp;L7</span>
      </div>
    </div>

    <div id="after_wrap_1" *ngIf="mode==2">
      <div class="float_left fontSize16">
        能力诊断
      </div>
      <div class="bar_bottom" id="after_wrap_1_left">
        <div class="bar_top level{{preLevel}}"></div>
      </div>
      <div id="after_wrap_1_right">
        <span class="fontSize16 wrap_text_1">L{{preLevel}}</span><span class="fontSize14">&nbsp;/&nbsp;L7</span>
      </div>
    </div>

    <div id="after_wrap_2" *ngIf="mode==2">
      <div class="float_left fontSize16">
        能力考核
      </div>
      <div class="bar_bottom" id="after_wrap_2_left">
        <div class="bar_top level{{postLevel}}" id="after_bar_top"></div>
      </div>
      <div id="after_wrap_2_right">
        <span class="fontSize16 wrap_text_1">L{{postLevel}}</span><span class="fontSize14">&nbsp;/&nbsp;L7</span>
      </div>
    </div>
  </div>

  <img src="../../assets/picture/reportnew/card1.png" [@card1Animation]="card1Show ? 'showCard1':'hideCard1'" alt="" class="card card1" (click)="detailClick1()">
  <img src="../../assets/picture/reportnew/card2_{{mode}}.png" [@card2Animation]="card2Show ? 'showCard2':'hideCard2'" class="card card2" (click)="detailClick2()">

  <div id="backButton" *ngIf="learningPathId=='not'" (click)="close()" [ngClass]="{'backPost': surveyType == 3, 'backPre': surveyType == 2}">
    <img src="../../assets/picture/learningmap/doublearrow.png" alt="" id="doubleArrow" />
    <span class="fontSize16" id="backText">返回主页</span>
  </div>



  <div id="chuan" *ngIf="mode==1">
    <p class="fontSize14 lineHeight24" [innerHtml]="chuanjie"></p>
  </div>
  <div id="courseBtn" *ngIf="learningPath && mode == 1 && !finishStatus" (click)="getCourse()" class="fontSize16">
    进入课程学习
  </div>

  <div id="bottom_space"></div>

  <div class="detail"  [@detail1Animation]="detail1Show ? 'showDetail1':'hideDetail1'" id="detail1">
    <div class="detailContent fontSize16" id="detailContent1">
        <h2 class="fontSize18">能力解读</h2>
        <div class="detailContentMain" [innerHtml]="description">

        </div>
    </div>
      <div class="detailClostBtn fontSize16" id="detailBtn1" (click)="detailBtnClick1()">
          我了解了，关闭
      </div>
  </div>

  <div class="detail" [@detail2Animation]="detail2Show ? 'showDetail2':'hideDetail2'" alt=""  id="detail2">
    <div class="detailContent fontSize16" id="detailContent2">
      <h2 class="fontSize18" *ngIf="mode==1">能力发展建议</h2>
      <h2 class="fontSize18" *ngIf="mode==2">综合回顾发展</h2>
      <div class="detailContentMain" [innerHtml]="development">

      </div>
    </div>
    <div class="detailClostBtn fontSize16" id="detailBtn2" (click)="detailBtnClick2()">
      我了解了，关闭
    </div>
  </div>

  <div id="nextWrap" *ngIf="mode==2 && learningPathId != 'not'" [ngClass]="{'nextWrapAfter': finishStatus == true, 'nextWrapBefore': finishStatus == false}"  (click)="finish()">
    <div id="nextStudy" *ngIf="finishStatus" class="nextStudy fontSize16">
      已完成本能力的学习
    </div>
    <div id="nextStudy" *ngIf="!finishStatus" class="nextStudy fontSize16">
      完成本能力的学习
    </div>
  </div>



  <div id="space2">

  </div>

  <div id="shade"></div>

</div>



// WEBPACK FOOTER //
// ./src/app/ability-test-report/ability-test-report.component.html